<div #screen class="container-fluid h-100" (window:resize)="onResize($event)">

    <div id="entity-management" class="row h-100">
        <div class="col-md-4 pr-0">
            <div id="entity-list" class="h-100">
                <dx-data-grid (onContentReady)="onContentReadyGroup($event)" #dataGrid [dataSource]="gridData"
                    noDataText="" (onInitialized)="onInitialized($event)" (onRowClick)="onRowClick($event)"
                    [allowColumnResizing]="false" [columnAutoWidth]="false">
                    <dxo-load-panel>
                        <div *dxTemplate="let data of 'content'">
                            <pdi-loader size="medium"></pdi-loader>
                        </div>
                    </dxo-load-panel>
                    <dxi-column alignment='center' width="150px" caption="Product Group No" dataField="Id"
                        dataType="number"></dxi-column>
                    <dxi-column alignment='left' caption="Product Group Name" dataField="Name"
                        dataType="string"></dxi-column>
                    <dxo-selection mode="single"> </dxo-selection>
                    <dxo-filter-row [visible]="true"> </dxo-filter-row>
                    <dxo-scrolling mode="standard"> </dxo-scrolling>
                    <dxo-sorting mode="single"> </dxo-sorting>
                    <dxo-pager [allowedPageSizes]="[10, 20, 30]" [showPageSizeSelector]="true"
                        [visible]="true"></dxo-pager>
                    <dxo-paging [pageSize]="20"> </dxo-paging>
                </dx-data-grid>
            </div>
        </div>
        <div id="entity-detail" class="col-md-8 pr-0">
            <div *ngIf="entityData && entityData.key">
                <form id="entity-form" #entityForm="ngForm" [style.height]="formHeight">
                    <div class=" container">
                        <div id="entity-errors" class="row">
                            <div class="col">
                                <facnm-errors></facnm-errors>
                            </div>
                        </div>
                        <div class="top-buffer">
                            <div class="col-md-12">

                                <div class="row form-group">
                                    <div class="col-lg-3 col-md-4 col-sm-4 hidden-xs"> </div>
                                    <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 control-label">
                                    <label for="Title" class="col-form-label">Product Group Number</label>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-1">
                                        <input [(ngModel)]="entityData.value.Id" type="text" class="form-custom-control control-look-input"
                                            readonly="readonly" name="Number">
                                        <div class="control-look"></div>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-3 col-md-4 col-sm-4 hidden-xs"> </div>
                                    <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 control-label">
                                        <label for="Title" class="col-form-label">Product Group Name </label>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-1">
                                        <input placeholder="Product Group Name" [(ngModel)]="entityData.value.Name"
                                            [ngClass]="{'modelstate-invalid': hasError('Name')}" type="text"
                                            class="form-custom-control control-look-input" name="Name" required
                                            maxlength="25">
                                        <div class="control-look"></div>
                                        <div class="error-message" *ngIf="hasError('Name')">
                                            <small class="error" *ngIf="checkError('Name','required')">
                                                Product Group Name is required
                                            </small>
                                            <small class="error" *ngIf="checkError('Name','maxlength')">
                                                Product Group Name cannot be longer than 25 characters
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <div style="clear:both;"></div>
                            <div class="collapsible-header-container top-buffer" (click)="PCollapse = !PCollapse">
                                <div class="collapsible-header-left collapsible-header-{{collapseColor}}">
                                    <div class="collapsible-header-icon" [ngClass]="collapseClass(PCollapse)"></div>
                                    <div class="text-center">
                                        <span class="collapsible-header-content collapsible-header-content-{{collapseColor}}">Products</span>
                                    </div>
                                </div>
                            </div>
                       
                            <div id="PCollapse" class="childs" [ngClass]="{'showChild': !PCollapse}">
                                
                                <div class="col-lg-12"> 
                                    <facnm-product-assignment [AssignedProducts]="entityData.value.AssignedProducts" 
                                     [UnAssignedProducts]="entityData.value.UnassignedProducts" [isAddForm] ="isAddForm"  >
                                    </facnm-product-assignment>
                                </div>
                            </div>
                            
                            <div style="clear:both;"></div>
                            <div class="collapsible-header-container top-buffer" (click)="VCollapse = !VCollapse">
                                <div class="collapsible-header-left collapsible-header-{{collapseColor}}">
                                    <div class="collapsible-header-icon" [ngClass]="collapseClass(VCollapse)"></div>
                                    <div class="text-center">
                                        <span class="collapsible-header-content collapsible-header-content-{{collapseColor}}">Data Areas</span>
                                    </div>
                                </div>
                            </div>
                       
                            <div id="VCollapse" class="childs" [ngClass]="{'showChild': !VCollapse}">                                
                                <div class="col-lg-12"> 
                                    <facnm-data-area-assignment [AssignedDataAreas]="entityData.value.AssignedDataAreas" 
                                     [UnAssignedDataAreas]="entityData.value.UnassignedDataAreas" [isAddForm] ="isAddForm"  >
                                    </facnm-data-area-assignment>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
            <facnm-action-buttons [entityName]="entityName" 
                [modelEntity]="entityData"></facnm-action-buttons>
        </div>
    </div>

    <ngx-smart-modal #modal identifier="modal"   [customClass]="'modal-custom config-modal'" (onClose)="saveRelatedProducts()"
    [closable]="true" [dismissable]="false" [escapable]="false">   
    <div class="modal-header" >
            <div class="modal-title model-header-label">Related Products</div>
    </div>

    <div class="modal-body modal-body-container" >       
        
        <div class="well text-center">
        The below related products will be added to the Product Group.
        </div>

        <div class="row p-4" >
            <div class="col">
                <table class="table table-hover">
            <thead>
                <tr>
                    <th>Related Products</th>
                </tr>
            </thead>
            <tr>
                <th class="col-md-6">Product Number</th>
                <th class="col-md-6">Product Name</th>
            </tr>
            <tr  *ngFor="let RelatedProduct of RelatedProducts" >
                <td>
                    {{RelatedProduct.ProductNumber}}
                </td>
                <td>
                    {{RelatedProduct.ShortProductName}}
                </td>
            </tr>
        </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="col-md-3 text-center">
            <button type="button" class="edit-button-green"  (click)="saveRelatedProducts()">
                <img src="assets/Content/Images/Icons/cancel.png" class="edit-button-image mr-2" />
                <span class="edit-button hidden-xs">OK</span>
            </button>
        </div>
    </div>
</ngx-smart-modal>

</div>

<facnm-delete-dialog [entityName]="entityName" ></facnm-delete-dialog>

<facnm-notifications [entityName]="entityName"></facnm-notifications>

<facnm-loading-screen-indicator></facnm-loading-screen-indicator>

<facnm-loading-entity-indicator></facnm-loading-entity-indicator>



